import { render, staticRenderFns } from "./FieldDisplay.vue?vue&type=template&id=054d5df4&scoped=true"
import script from "./FieldDisplay.vue?vue&type=script&lang=js"
export * from "./FieldDisplay.vue?vue&type=script&lang=js"
import style0 from "./FieldDisplay.vue?vue&type=style&index=0&id=054d5df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d5df4",
  null
  
)

export default component.exports